import { Box, Button, HStack, Icon, IconButton, Text, VStack } from '@genial/components';
import { BoxBorder, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useMemo } from 'react';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { transferStatusHistoryQuery } from '../../../../store/customerDetail/SecuritiesTransfer/selector';
import { TransferStatusHistoryItem } from '../../../../store/customerDetail/SecuritiesTransfer/types';
import { StatusTimeline, StatusTimelineLoading } from '../StatusTimeline';

export interface TransferHistoryContentProps {
  protocolNumber: string;
  productName?: string;
  customerName: string;
  customerSinacorAccount: string;
  customerCpfCnpj: string;
  history?: TransferStatusHistoryItem[];
  onClose: () => void;
}

export const TransferHistoryContent: React.FC<TransferHistoryContentProps> = ({
  protocolNumber,
  productName,
  customerName,
  customerSinacorAccount,
  customerCpfCnpj,
  history,
  onClose,
}) => {
  const { data, loading } = useRecoilQuery(
    transferStatusHistoryQuery({ protocolNumber, customerCpfCnpj }),
    { if: () => !history }
  );

  const historyData = history || data?.data || [];

  const rowsCount = useMemo(() => Math.floor(Math.random() * 4 + 2), []);

  return (
    <VStack
      flex={1}
      padding="inline.xxs"
      space="stack.xxxs"
      bgColor="neutral.white"
      overflowY="scroll">
      <HStack w="full" justifyContent="space-between" alignItems="center">
        <Button
          p={0}
          variant="textLink"
          leftIcon={<Icon name="ArrowLeft" size="xxs" color="neutral.black" />}
          onPress={onClose}
          _text={{
            textTransform: 'none',
            color: 'neutral.black',
            fontSize: Typography['fontsize.lg'],
          }}>
          Status da solicitação
        </Button>
        <IconButton
          testId="close-transfer-history-modal"
          p={0}
          icon="CloseModal"
          iconSize="xxs"
          borderWidth="1"
          borderColor="brand.primary.principal"
          iconColor="brand.primary.principal"
          onPress={onClose}
        />
      </HStack>

      <VStack
        bgColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
        borderRadius={BoxBorder.heavy}
        p="inset.xs"
        space="stack.nano">
        <HStack justifyContent="space-between">
          <Text>Nome do cliente</Text>
          <Text variant="semibold" color="neutral.black">
            {customerName}
          </Text>
        </HStack>
        <HStack justifyContent="space-between">
          <Text>Conta sinacor</Text>
          <Text color="neutral.darkest" variant="semibold">
            {customerSinacorAccount}
          </Text>
        </HStack>
      </VStack>

      {!!productName && (
        <Text variant="semibold" fontSize="xl" color="neutral.black">
          {productName}
        </Text>
      )}

      <Box>
        <Text variant="semibold" fontSize="lg" color="neutral.black">
          Acompanhe o status da solicitação de portabilidade:
        </Text>
      </Box>

      {loading ? (
        <StatusTimelineLoading rowsCount={rowsCount} />
      ) : (
        <StatusTimeline items={historyData} />
      )}
    </VStack>
  );
};
